module.exports = __webpack_public_path__ + "static/media/target-revenue.1d9e28f8.svg";